import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../consts/api";

export const useSaveDeviceServices = (id, options = {}) => {
  const res = useMutation(
    (dto) => http.post(HTTP_ENDPOINTS.saveDeviceServices(id), dto),
    { ...options },
  );
  return res;
};
